import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Flex, FormContext } from 'dash-ui';
import { RoleTypesEnum } from 'dash-common';

import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import { useGetDevelopersAsSaleUsersBySaleTeamAndRoleQuery } from 'gql/generated.graphql';

const SaleAssociateSelect = ({
  saleTeamIndex,
  disabled,
}: {
  saleTeamIndex: number;
  disabled?: boolean;
}) => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);

  const { saleTeamId, saleAssociateIds } =
    formState[FormFields.SaleTeams][saleTeamIndex] || {};

  const { data, loading } = useGetDevelopersAsSaleUsersBySaleTeamAndRoleQuery({
    variables: {
      saleTeamId,
      roleType: RoleTypesEnum.ORG_SALES_ASSOCIATE as any,
    },
    skip: !saleTeamId,
    fetchPolicy: 'network-only',
  });

  const users = data?.getDevelopersAsSaleUsersBySaleTeamAndRole || [];

  const onSelectChange = (value: any, values: any) => {
    const saleTeams = [...formState[FormFields.SaleTeams]];

    saleTeams[saleTeamIndex] = {
      ...saleTeams[saleTeamIndex],
      saleAssociateIds: values,
    };

    stateHandlers[FormFields.SaleTeams](saleTeams);
  };

  return (
    <Flex flexDirection="column" flex={1}>
      <Form.Label>{t('forms:labels.salesAssociate')}</Form.Label>
      <Form.Select
        isClearable
        menuPortalZIndex="auto"
        isLoading={loading}
        options={users.map((item) => ({
          value: item._id,
          label: item.profile.lastName
            ? `${item.profile.firstName} ${item.profile.lastName}`
            : item.profile.firstName,
        }))}
        isMulti
        disabled={!saleTeamId || disabled}
        onChanged={onSelectChange}
        value={saleAssociateIds}
        placeholder={t('forms:placeholders.salesAssociate')}
        w="100%"
        $errorType={
          formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.saleAssociateIds
            ?.type
        }
      />
      <Form.Feedback
        $errorType={
          formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.saleAssociateIds
            ?.type
        }
      >
        {
          formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.saleAssociateIds
            ?.message
        }
      </Form.Feedback>
    </Flex>
  );
};

export default SaleAssociateSelect;
